// ----------------------------------------------------------------------

export default function Tabs(theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          fontWeight: theme.typography.fontWeightMedium,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          '&.Mui-selected': {
            color: theme.palette.text.primary,
            borderBottom: `2px solid ${theme.palette.primary.main}`
          },
          '&:not(:last-child)': {
            marginRight: theme.spacing(5)
          },
          '@media (min-width: 600px)': {
            minWidth: 48
          }
        },
        labelIcon: {
          minHeight: 48,
          paddingTop: 0,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          '& > .MuiTab-wrapper': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& > *:first-of-type': {
              marginRight: theme.spacing(1)
            }
          },
          '& .MuiTab-iconWrapper': {
            marginBottom: 0,
            marginRight: theme.spacing(1) // Adjust the margin as needed
          }
        },
        wrapper: {
          flexDirection: 'row', // Ensure that icon and text stay in the same row
          alignItems: 'center', // Center them vertically
          '& > *:first-of-type': {
            marginRight: theme.spacing(1) // Margin after the icon
          }
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: '50%'
        }
      }
    }
  };
}
